import React from 'react';
import { ClusterPageTemplate } from '../components/ClusterPageTemplate';
export function ClusterCafeLunchroomPage() {
  return <ClusterPageTemplate clusterName="Café & Lunchroom" sectorName="Horeca & Hospitality" sectorSlug="horeca-hospitality" heroTitle="Website laten maken voor een café of lunchroom" heroDescription="Een frisse, uitnodigende website voor jouw koffiezaak, lunchroom of café. Wij bouwen websites die jouw unieke sfeer online perfect weergeven." websiteOnderdelen={[{
    icon: 'UtensilsIcon',
    title: 'Menukaart',
    description: 'Een overzichtelijke, mobielvriendelijke menukaart voor ontbijt, lunch, borrel of diner.'
  }, {
    icon: 'CameraIcon',
    title: 'Sfeer & Interieur',
    description: "Laat zien hoe gezellig het bij jullie is met mooie foto's van de zaak en het terras."
  }, {
    icon: 'UsersIcon',
    title: 'Groepen & Feesten',
    description: 'Informatie over de mogelijkheden voor high teas, borrels, babyshowers of besloten feesten.'
  }, {
    icon: 'MapPinIcon',
    title: 'Locatie & Openingstijden',
    description: 'Direct zichtbaar op de homepage: waar zitten jullie en wanneer zijn jullie open?'
  }]} functionaliteiten={[{
    icon: 'FileTextIcon',
    title: 'Aanvraagformulier',
    description: 'Speciale formulieren voor groepsreserveringen of het aanvragen van een offerte voor een feestje.'
  }, {
    icon: 'StarIcon',
    title: 'Instagram feed',
    description: "Koppel je Instagram-account zodat je nieuwste, sfeervolle foto's automatisch op de website verschijnen."
  }, {
    icon: 'SearchIcon',
    title: 'Lokale vindbaarheid',
    description: "Zorg dat je gevonden wordt als mensen in de buurt zoeken naar 'koffie drinken' of 'lunchroom'."
  }]} siblingClusters={[{
    name: 'Restaurant',
    slug: 'restaurant'
  }, {
    name: 'Hotel & B&B',
    slug: 'hotel-bb'
  }, {
    name: 'Afhaal & Bezorg',
    slug: 'afhaal-bezorg'
  }]} faqs={[{
    q: 'Heb ik wel een website nodig als ik al Instagram heb?',
    a: 'Ja. Instagram is geweldig voor sfeer, maar een website is cruciaal om gevonden te worden in Google, je menukaart overzichtelijk te tonen en groepsreserveringen binnen te halen.'
  }, {
    q: 'Kan ik zelf de lunchkaart aanpassen?',
    a: 'Ja, we bouwen een heel eenvoudig systeem waarmee je zelf prijzen kunt aanpassen of nieuwe broodjes aan de kaart kunt toevoegen.'
  }, {
    q: 'Wat kost een website voor een lunchroom?',
    a: 'Een frisse, professionele website voor een café of lunchroom start vanaf €1.500. Dit is inclusief het inrichten van je menukaart.'
  }, {
    q: 'Kunnen we ook vacatures op de site plaatsen?',
    a: "Zeker. We kunnen een speciale 'Werken bij' pagina toevoegen waar je openstaande vacatures kunt plaatsen met een simpel sollicitatieformulier."
  }]} data-id="element-1074" />;
}